import { ChangeDetectionStrategy, Component } from '@angular/core';

import { PANE2_TILES } from '../../data/walkthrough.fixtures';

/**
 * Pane 2 / 8 — `What Koomzo is` (specs/auth.md §5.4).
 *
 * Copy, a 2×2 tile grid, and ONE summary node beneath it. This is the closest
 * the eight panes come to a duplicate — pane 5 uses the same `.vgrid`/`.vmod`
 * atoms — and it is still not the same composition: four tiles plus a summary
 * against eight tiles and nothing. The shared atoms live in
 * `styles/_walkthrough-viz.scss`; the compositions do not.
 *
 * The summary node is the one node in the feature drawn in primary wash with a
 * primary outline (the source does it with two inline styles). It says "one
 * platform underneath", so it is the only node that is not a peer of the tiles
 * above it — hence a modifier rather than a default.
 */
@Component({
  selector: 'app-walkthrough-pane2',
  standalone: false,
  templateUrl: './walkthrough-pane2.component.html',
  styleUrls: ['./walkthrough-pane2.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WalkthroughPane2Component {
  readonly tiles = PANE2_TILES;
}
